import React from "react";
import Button from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import ReadOnlyTextField from "../../../Components/readOnlyTextField/readOnlyTextField";
import TextField from "../../../Components/textField/textField";
import Select from '../../../Components/select/select';
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css";

export default class AltFactory extends React.Component {
  state = {
    factorys: [],
    factorysID: [],
    code: null,
    description: "",
    id: 0,
    message: "",
    reload: false,
    show: false,
    focused:false,
    readOnly: true,
    notification: false,
    notification_type: 'success',
    notification_message: ''
  };

  componentDidMount() {
    Api.get("/factorys/").then((resp) => {
      let arr = [];
      resp.data.forEach((element) => {
        arr.push({ value: element.id, label:element.description });
      });
      this.setState({ factorys: arr, factorysID: [...resp.data] });
    });
  }

  SelectFactory = (childData) => {
    this.setState({readOnly: false});
    const { description, id, code } = this.state.factorysID.find(
      (v) => v.id === childData
    );
    this.setState({ description: description, id: id, code: code });
  };

  sendData = (id) => {
    if (id > 0 && this.state.description != null && this.state.description != "") {
      Api.put(`/factorys/${id}`, {
        description: this.state.description,
      })
        .then(() => {
          this.setState({notification: true, notification_message: "Planta editada com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        })
        .catch((error) => {
          this.setState({ message: "" + error.message, show: true });
        });
    } else {
      this.setState({
        message: "Necessário preencher todos os campos.",
        show: true,
      });
    }
  };

  changeValue = (value) => {
    this.setState({ description: value });
  };
  callbackfunction = () => {
    this.setState({ show: false });
  };

  render() {
    let { show, message, reload, notification, notification_message, notification_type } = this.state;
    return (
      <div className="box">
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
      <div className='cont_alt_fac form'>
      <h4>Alterar Planta</h4>
        {show ? (
          <Alert
            show={show}
            message={message}
            parentCallback={this.callbackfunction}
            reload={reload}
          />
        ) : null}
        <div className="inputs">
        <div className='select element'>
          <Select
            autoSelect={true}
            id='drop'
            label="Selecionar Planta"
            arrData={this.state.factorys}
            handleSelect={this.SelectFactory}
          />
        </div>
        <div className="element">
          <TextField
            section={false}
            title="Descrição"
            min={3}
            max={30}
            value={this.state.description}
            validationType="varchar"
            altType={true}
            parentCallback={this.changeValue}
            readOnly={this.state.readOnly}
          />
        </div>
        <div className="element">
          <ReadOnlyTextField showValue={this.state.code} title="Código" />
        </div>
        </div>
        <div className='altFacBtn submitButton'>
          <Button
            title="Alterar"
            parentCallback={() => this.sendData(this.state.id)}
          />
        </div>
      </div>
      </div>
    );
  }
}
